import type { Control, FieldErrors } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import { NumericTextField } from 'ui/components/NumericTextField'
import { CreateFormGridItem } from 'ui/ManagerFinance/components'
import { ErrorMessage } from 'ui/ManagerFinance/utils/components'
import type { LoanEventCreateFormInputs } from './validation'
import { useIntl } from 'react-intl'

type Props = {
	control: Control<LoanEventCreateFormInputs>
	errors: FieldErrors<LoanEventCreateFormInputs>
	disabled: boolean
	title: string
}

function LoanEventCreateSharegroupTableAmountInput({
	control,
	errors,
	disabled,
	title,
}: Props) {
	const intl = useIntl()

	const amountKey = 'amount'
	const unitsKey = 'units'

	return (
		<>
			<CreateFormGridItem
				key={amountKey}
				$fullWidth={false}
				style={{
					display: 'flex',
					flexDirection: 'column',
				}}
			>
				<Controller
					name={amountKey}
					control={control}
					render={({ field: { onChange, value: currentValue } }) => (
						<NumericTextField
							id="amount-numeric-input"
							label={title}
							required={true}
							lineDirection="center"
							floating
							fullWidth
							error={errors[amountKey] !== undefined}
							disabled={disabled}
							value={currentValue}
							onChange={onChange}
							min={0}
						/>
					)}
				/>
				{errors[amountKey]?.message && (
					<ErrorMessage style={{ marginBottom: '0.5rem' }}>
						{errors[amountKey]?.message}
					</ErrorMessage>
				)}
			</CreateFormGridItem>
			<CreateFormGridItem key={unitsKey} $fullWidth={false}>
				<Controller
					name={unitsKey}
					control={control}
					render={({ field: { onChange, value: currentValue } }) => (
						<NumericTextField
							id="units-numeric-input"
							label={intl.formatMessage({
								defaultMessage: 'Yksiköt',
								description: 'Units',
							})}
							required={true}
							lineDirection="center"
							floating
							fullWidth
							error={errors[unitsKey] !== undefined}
							disabled={true}
							value={currentValue as number}
							onChange={onChange}
							min={0}
						/>
					)}
				/>
				{errors[unitsKey]?.message && (
					<ErrorMessage style={{ marginBottom: '0.5rem' }}>
						{errors[unitsKey]?.message}
					</ErrorMessage>
				)}
			</CreateFormGridItem>
		</>
	)
}

export default LoanEventCreateSharegroupTableAmountInput
